import script from "./SidebarFan.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarFan.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarFan.vue?vue&type=style&index=0&id=e633f488&lang=scss&scoped=true"
import "./SidebarFan.vue?vue&type=style&index=1&id=e633f488&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e633f488"]])

export default __exports__